import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EmailSmsPreviewModalComponent} from "./email-sms-preview-modal.component";
import { ButtonModule } from '@xref/xref-lib';


@NgModule({
  declarations: [EmailSmsPreviewModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [EmailSmsPreviewModalComponent]
})
export class EmailSmsPreviewModalModule { }
